<template>
	<div class="supplier-csr" :class="{ 'supplier-csr--portal': isPortalView, 'supplier-csr--compact': compact }">
		<h2 class="text-center darkColor--text supplier-csr-title">{{ title }}</h2>
		<div class="supplier-csr-rings">
			<div
				v-for="item in ringItems"
				:key="item.key"
				class="supplier-csr-ring"
				:class="{ inactive: item.score == null || item.score === 0 }"
			>
				<h3 class="supplier-csr-label" :style="{ color: item.labelColor }">
					{{ item.label }}
				</h3>
				<vue-ellipse-progress
					:progress="item.progress"
					:thickness="ringThickness"
					:size="ringSize"
					:emptyColor="item.score ? '#d7d7d7' : '#b1b3b2'"
					:color="item.score ? item.color : '#b1b3b2'"
					class="supplier-csr-ellipse"
				>
					<v-img
						:src="item.icon"
						:max-width="iconSize"
						contain
					/>
				</vue-ellipse-progress>
				<div class="supplier-csr-score" :style="{ color: item.labelColor }">
					{{ item.score ? Math.ceil(item.score) + "%" : "-" }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { VueEllipseProgress } from "vue-ellipse-progress"
export default {
	name: "SupplierCSR",
	props: {
		title: String,
		score1: Number,
		score2: Number,
		score3: Number,
		score4: Number,
		isPortalView: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		}
	},
	components: { VueEllipseProgress },
	computed: {
		ringSize() {
			if (this.compact) return 96
			return this.isPortalView ? 100 : 200
		},
		ringThickness() {
			if (this.compact) return 10
			return this.isPortalView ? 12 : 20
		},
		iconSize() {
			if (this.compact) return "42px"
			return this.isPortalView ? "46px" : "120px"
		},
		ringItems() {
			return [
				{
					key: "hr",
					label: "HUMAN RIGHTS",
					score: this.score1,
					progress: this.score1 || 100,
					color: "#1E7C83",
					labelColor: "#1E7C83",
					icon: require("../assets/Global_Compact_HumanRights.svg"),
				},
				{
					key: "labour",
					label: "LABOUR",
					score: this.score2,
					progress: this.score2 || 100,
					color: "#DE8F18",
					labelColor: "#1E7C83",
					icon: require("../assets/Global_Compact_Labour.svg"),
				},
				{
					key: "env",
					label: "ENVIRONMENT",
					score: this.score3,
					progress: this.score3 || 100,
					color: "#1E7C83",
					labelColor: "#1E7C83",
					icon: require("../assets/Global_Compact_Environment.svg"),
				},
				{
					key: "anti",
					label: "ANTICORRUPTION",
					score: this.score4,
					progress: this.score4 || 100,
					color: "#DE8F18",
					labelColor: "#1E7C83",
					icon: require("../assets/Global_Compact_AntiCorruption.svg"),
				},
			]
		},
	},
}
</script>

<style scoped>
.inactive {
	filter: grayscale(100%);
}

.supplier-csr {
	width: 100%;
}

.supplier-csr-title {
	margin: 0 0 16px;
	font-size: 1.35rem;
	line-height: 1.3;
	min-height: 2.6em;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}

.supplier-csr-rings {
	display: flex;
	flex-wrap: nowrap;
	align-items: flex-start;
	justify-content: space-between;
	gap: 24px;
	width: 100%;
}

.supplier-csr-ring {
	flex: 0 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.supplier-csr-label {
	font-size: 0.85rem;
	font-weight: 700;
	letter-spacing: 0.02em;
	margin: 0 0 8px;
	line-height: 1.15;
	min-height: 2.3em;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	text-align: center;
}

.supplier-csr-ellipse {
	margin: 0 auto;
}

.supplier-csr-score {
	font-size: 1.75rem;
	font-weight: 700;
	margin-top: 8px;
	line-height: 1.2;
}

.supplier-csr--portal .supplier-csr-title {
	font-size: 1.05rem;
	min-height: 2.8em;
	margin-bottom: 12px;
}

.supplier-csr--portal .supplier-csr-rings {
	gap: 22px;
	justify-content: center;
}

.supplier-csr--portal .supplier-csr-ring {
	flex: 0 0 auto;
	width: 118px;
	padding: 0;
}

.supplier-csr--portal .supplier-csr-label {
	font-size: 0.58rem;
	min-height: 2.2em;
	margin-bottom: 4px;
}

.supplier-csr--portal .supplier-csr-score {
	font-size: 1.15rem;
	margin-top: 4px;
}

.supplier-csr--portal .supplier-csr-ellipse >>> .v-image,
.supplier-csr--portal .supplier-csr-ellipse >>> img {
	max-width: 46px !important;
	max-height: 46px !important;
}

.supplier-csr--compact .supplier-csr-title {
	font-size: 1.05rem;
	min-height: 0;
	margin-bottom: 12px;
}

.supplier-csr--compact .supplier-csr-rings {
	gap: 8px;
	justify-content: center;
}

.supplier-csr--compact .supplier-csr-ring {
	flex: 1 1 0;
	min-width: 0;
	max-width: 150px;
}

.supplier-csr--compact .supplier-csr-label {
	font-size: 0.68rem;
	min-height: 2.4em;
	margin-bottom: 4px;
}

.supplier-csr--compact .supplier-csr-score {
	font-size: 1.15rem;
	margin-top: 4px;
}

.supplier-csr--compact .supplier-csr-ellipse >>> .v-image,
.supplier-csr--compact .supplier-csr-ellipse >>> img {
	max-width: 42px !important;
	max-height: 42px !important;
}
</style>
